import React from 'react';

interface SocialLinksProps {
  className?: string;
  iconSize?: number;
  variant?: 'menu' | 'footer';
}

function SocialLinks({ className = '', iconSize = 20, variant = 'footer' }: SocialLinksProps) {
  const baseIconClass = variant === 'menu' 
    ? 'text-[#f5f5f7] hover:text-[#0171E3]' 
    : 'text-[#86868b] hover:text-white';

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <a
        href="instagram://user?username=cargo_9_"
        target="_blank"
        rel="noopener noreferrer"
        className={`group relative p-1 rounded-full ${baseIconClass}`}
        aria-label="Instagram"
      >
        <img 
          src="https://i.ibb.co/Q7tW3w4L/instagram-2504918.png"
          alt="Instagram"
          className="w-5 h-5"
        />
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-black/80 rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all pointer-events-none whitespace-nowrap">
          Instagram
        </span>
      </a>
      
      <a
        href="https://t.me/ACargo"
        target="_blank"
        rel="noopener noreferrer"
        className={`group relative p-1 rounded-full ${baseIconClass}`}
        aria-label="Telegram"
      >
        <img 
          src="https://i.ibb.co/MDnFxxfw/telegram-2504941.png"
          alt="Telegram"
          className="w-5 h-5"
        />
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-black/80 rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all pointer-events-none whitespace-nowrap">
          Telegram
        </span>
      </a>
      
      <a
        href="https://youtube.com/@taisheni=dgMfHiYagmJw4GBF"
        target="_blank"
        rel="noopener noreferrer"
        className={`group relative p-1 rounded-full ${baseIconClass}`}
        aria-label="YouTube"
      >
        <img 
          src="https://i.ibb.co/rGFcQf4Y/youtube-2504965.png"
          alt="YouTube"
          className="w-5 h-5"
        />
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-black/80 rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all pointer-events-none whitespace-nowrap">
          YouTube
        </span>
      </a>
      
      <a
        href="https://vk.com/car7"
        target="_blank"
        rel="noopener noreferrer"
        className={`group relative p-1 rounded-full ${baseIconClass}`}
        aria-label="VK"
      >
        <img 
          src="https://i.ibb.co/DD2c9M6L/vk-2504953.png"
          alt="VK"
          className="w-5 h-5"
        />
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-black/80 rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all pointer-events-none whitespace-nowrap">
          VK
        </span>
      </a>
    </div>
  );
}

export default SocialLinks;